import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import DOMPurify from 'dompurify';

import { ImageContext, ImageContextProvider } from '../context/imageContext.js'

import { MultiCarouselR } from './multiCarousel.js';
import { OpenSeaDragonViewer } from './osdViewer.js';

import '../../css/imageViewer.scoped.scss';

/*
FIXME: let OSD handle the sequence, just track the index# and tell MultiCarousel
*/

const ImageViewerItem = (props) => {

  const [ selDataIdx, setSelDataIdx ] = useState(props.selDataIdx);
  useEffect(() => {
    setSelDataIdx(props.selDataIdx);
  }, [props.selDataIdx]);

  const itemClickHandler = (event) => {
    props.itemClickAction(event, props.data, props.idx);
    setSelDataIdx(props.idx);
    props.setSelFunc(event);
  }

  const getFreeHeightThumb = (thumb) => {
    const i = thumb.indexOf('&h=');
    return thumb.substring(0, i);
  }

  return (
    <div className={`item ${props.itemClass}`}>
      <div className={`grid-viewer-container ${props.idx === selDataIdx ? 'selected' : ''}`}>
          <a className=""
            href="javascript:;"
            onClick={itemClickHandler}
            onFocus={props.focusfunc}
            aria-current={props.idx === selDataIdx ? 'true' : null}
            style={{userSelect: 'none'}}
          >
          <div className="grid-image-container-slider grid-viewslider">
            <figure>
              <img src={props.data.thumb}
                alt={props.data.alt ?? `Image ${props.idx + 1}`}
                style={{width: props.imgWidth, height: 'auto', maxHeight: 2 * props.imgWidth}}
              />
            </figure>
          </div>
          </a>
      </div>
      {/* <div className="image-viewer-thumb-num">
        {props.idx + 1}
      </div> */}
    </div>
  )
}

export function normalizeTileSource(image) {

  return {
          ...image,
          thumb: image.iiifThumb,
          label: image.label ?? '', // '<p>Placeholder Caption<br></p><p>With multiple lines</p>',
          tileSource: [`${image.iiifManifest}`]
          }
}

export const ImageViewer = (props) => {

  if (!props.images || props.images.length === 0) return null;

  const displaySlots = 5; // should be an odd number
  const initEmptySlots = Math.max(0, Math.floor((displaySlots - props.images.length) / 2));
  const initialDisplayIdx = Math.floor(displaySlots / 2) - initEmptySlots;

  const [ itemWidth, setItemWidth ] = useState(130);
  const [ imgWidth, setImgWidth ] = useState(96);

  const [image, setImage] = useState( props.images.length > 0 ? props.images[0] : '');

  const openImageInViewer = (e, data, idx) => {
    setImage(data);
    document.querySelector("#openSeaDragon .openseadragon-canvas").focus();
  }

  return (
    <div className="mx-0">
      <div className="px-0">
        <OpenSeaDragonViewer home
          homeTooltip={props.homeTooltip}
          zoomOutTooltip={props.zoomOutTooltip}
          zoomInTooltip={props.zoomInTooltip}
          fullPageTooltip={props.fullPageTooltip}
          image={image}
        />
        <div className="entity-image-viewer-caption pt-2" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(image.label)}} ></div>
        <MultiCarouselR
          itemWidth={itemWidth}
          displaySlots={displaySlots}
          alignMode={'center'}
          alwaysShowButtons={false}
          maxWidth={614}
          variableWidth={false}
          imgWidth={imgWidth}
          buttonClass={'sliding-button'}
          selectedIdx={0}
        >
        {
          props.images.map((hit, idx) => {
              return <ImageViewerItem
                itemClickAction={openImageInViewer}
                itemClass={'viewer-slider'}
                data={hit}
                key={idx}
              />
          })
        }
        </MultiCarouselR>
      </div>
    </div>
  )
}

window.addEventListener('DOMContentLoaded', (event) => {

    if (document.getElementById('entityImageViewerRoot')) {
        ReactDOM.createRoot(document.getElementById('entityImageViewerRoot')).render(<ImageViewer {...entityImageViewerRoot.dataset} images={JSON.parse(entityImageViewerRoot.dataset.representation)?.map( item => normalizeTileSource(item) ) ?? []} />);
    }

})